import { namePaths } from '../auth.js'
import { list_users } from './list/list_users.js';
import { datos_afiliado } from './datos/datos_afiliado.js';
import { datos_asesor } from './datos/datos_asesor.js';
import { datos_contacto } from './datos/datos_contacto.js';
import { datos_razon } from './datos/datos_razon.js';
import { descuentos_referido } from './otros/descuentos_referido.js';
import { info_afiliacion } from './info/info_afiliacion.js';
import { info_egresos } from './info/info_egresos.js';
import { info_ingresos } from './info/info_ingresos.js';
import { info_aportes } from './info/info_aportes.js';
import { info_nomina } from './info/info_nomina.js';
import { info_liquidacion } from './info/info_liquidacion.js';
import { info_incapacidades } from './info/info_incapacidades.js';
import { list_afp } from './list/list_afp.js';
import { list_arl } from './list/list_arl.js';
import { list_ccf } from './list/list_ccf.js';
import { list_documento } from './list/list_documento.js';
import { list_eps } from './list/list_eps.js';
import { list_estado } from './list/list_estado.js';
import { list_otros } from './list/list_otros.js';
import { list_forma } from './list/list_forma.js';
import { list_cuentas } from './list/list_cuentas.js';
import { list_riesgo } from './list/list_riesgo.js';
import { list_servicios } from './list/list_servicios.js';
import { list_subtipo } from './list/list_subtipo.js';
import { list_tipo } from './list/list_tipo.js';
import { multiple_servicios } from './multiple/multiple_servicios.js';
import { nomina_devengados } from './otros/nomina_devengados.js';
import { nomina_deducidos } from './otros/nomina_deducidos.js';
import { notas_pendientes } from './otros/notas_pendientes.js';
import { liquidacion_devengados } from './otros/liquidacion_devengados.js';
import { liquidacion_deducidos } from './otros/liquidacion_deducidos.js';
import { afiliacion_registro } from './otros/afiliacion_registro.js';
import { aportes_registro } from './otros/aportes_registro.js';
import { afiliado_inclusiones } from './otros/afiliado_inclusiones.js';
import { afiliado_documentos } from './otros/afiliado_documentos.js';
import { afiliado_beneficiarios } from './otros/afiliado_beneficiarios.js';
import { archivo_plano } from './otros/archivo_plano.js';
import { servicios_activos } from './otros/servicios_activos.js';
import { servicios_inits } from './otros/servicios_inits.js';
import { servicios_nuevos } from './otros/servicios_nuevos.js';
import { precios } from './otros/precios.js';
import { base } from './otros/base.js';
import { predeterminados } from './otros/predeterminados.js';
import { subir_archivos } from './otros/subir_archivos.js';
import { ultima_conexion } from './otros/ultima_conexion.js';
import { tabla_campos } from './otros/tabla_campos.js';
import { autorizar } from './otros/autorizar.js';

export const asign_data = () => {
    var permisos_modulos = {
        admin: { precios: false, usuarios: false, razones: false, asesores: false, centros: false, servicios: false },
        afiliacion: { nueva: false, pendientes: false, documentos: false, inclusiones: false, registros: false, servicios: false, descargar: false },
        aportes: { cuentas: false, registrar: false, descargar: false, registros: false, pendientes: false },
        informes: { afiliaciones: false, aportes: false, comisiones: false, egresos: false, listados: false },
        servicios: { afiliacion: false, aportes: false, listados: false },
        archivo: { aportes: false, retiros: false, },
        afiliado: { ficha: false, incapacidades: false, nomina: false, liquidacion: false, crear: false },
        alertas: { autorizar: false, servicios: false },
    }
    var asign_dataForm = {}
    var asign_dataMultiple = {}
    var asign_predeterminados = {}
    var asign_dataPost = {}
    var asign_dataGet = { header: { data: [] } }
    var asign_dataIndex = {}
    var asign_datadb = {
        afiliado_beneficiarios: afiliado_beneficiarios().afiliado_beneficiarios,
        afiliado_documentos: afiliado_documentos().afiliado_documentos,
        afiliado_inclusiones: afiliado_inclusiones().afiliado_inclusiones,
        afiliacion_registro: afiliacion_registro().afiliacion_registro,
        aportes_registro: aportes_registro().aportes_registro,
        archivo_plano: archivo_plano().archivo_plano,
        autorizar: autorizar().autorizar,
        base: base().base,
        datos_afiliado: datos_afiliado().datos_afiliado,
        datos_asesor: datos_asesor().datos_asesor,
        datos_contacto: datos_contacto().datos_contacto,
        datos_razon: datos_razon().datos_razon,
        descuentos_referido: descuentos_referido().descuentos_referido,
        info_afiliacion: info_afiliacion().info_afiliacion,
        info_aportes: info_aportes().info_aportes,
        info_egresos: info_egresos().info_egresos,
        info_ingresos: info_ingresos().info_ingresos,
        info_nomina: info_nomina().info_nomina,
        info_liquidacion: info_liquidacion().info_liquidacion,
        info_incapacidades: info_incapacidades().info_incapacidades,
        list_afp: list_afp().list_afp,
        list_arl: list_arl().list_arl,
        list_ccf: list_ccf().list_ccf,
        list_cuentas: list_cuentas().list_cuentas,
        list_documento: list_documento().list_documento,
        list_eps: list_eps().list_eps,
        list_estado: list_estado().list_estado,
        list_forma: list_forma().list_forma,
        list_otros: list_otros().list_otros,
        list_riesgo: list_riesgo().list_riesgo,
        list_servicios: list_servicios().list_servicios,
        list_subtipo: list_subtipo().list_subtipo,
        list_tipo: list_tipo().list_tipo,
        list_users: list_users().list_users,
        multiple_servicios: multiple_servicios().multiple_servicios,
        nomina_deducidos: nomina_deducidos().nomina_deducidos,
        nomina_devengados: nomina_devengados().nomina_devengados,
        notas_pendientes: notas_pendientes().notas_pendientes,
        liquidacion_deducidos: liquidacion_deducidos().liquidacion_deducidos,
        liquidacion_devengados: liquidacion_devengados().liquidacion_devengados,
        precios: precios().precios,
        predeterminados: predeterminados().predeterminados,
        servicios_activos: servicios_activos().servicios_activos,
        servicios_inits: servicios_inits().servicios_inits,
        servicios_nuevos: servicios_nuevos().servicios_nuevos,
        subir_archivos: subir_archivos().subir_archivos,
        tabla_campos: tabla_campos().tabla_campos,
        ultima_conexion: ultima_conexion().ultima_conexion,
    }

    var dataForm_object = {}

    dataForm_object = Object.assign(dataForm_object,
        afiliado_beneficiarios(),
        list_users(),
        datos_afiliado(),
        datos_asesor(),
        datos_contacto(),
        datos_razon(),
        descuentos_referido(),
        info_afiliacion(),
        info_ingresos(),
        info_aportes(),
        info_egresos(),
        info_nomina(),
        info_liquidacion(),
        info_incapacidades(),
        list_afp(),
        list_arl(),
        list_ccf(),
        list_documento(),
        list_eps(),
        list_estado(),
        list_forma(),
        list_cuentas(),
        list_riesgo(),
        list_servicios(),
        list_subtipo(),
        list_tipo(),
        multiple_servicios(),
        nomina_devengados(),
        nomina_deducidos(),
        notas_pendientes(),
        liquidacion_devengados(),
        liquidacion_deducidos(),
        afiliado_inclusiones(),
        afiliado_documentos(),
        afiliacion_registro(),
        aportes_registro(),
        servicios_activos(),
        servicios_inits(),
        servicios_nuevos(),
        list_otros(),
        precios(),
        subir_archivos(),
        ultima_conexion(),
        tabla_campos(),
        predeterminados(),
        base(),
        archivo_plano(),
        autorizar()
    )


    var routes = namePaths();
    routes.push('configuracion')
    var tablas = Object.keys(dataForm_object);

    for (var m = 0; m < routes.length; m++) {
        asign_dataPost[routes[m]] = {
            data: [],
            route: '',
            tablaPost: [],
            tablaAuditar: true,
            tablaDelete: [],
            notaDelete: null,
        }
        asign_dataGet[routes[m]] = {
            data: [],
        }
        asign_dataIndex[routes[m]] = false
        for (var i = 0; i < tablas.length; i++) {
            var campos = Object.keys(dataForm_object[tablas[i]]);
            for (var j = 0; j < campos.length; j++) {
                var createdataform = dataForm_object[tablas[i]][campos[j]].namepath
                for (var k = 0; k < createdataform.length; k++) {
                    if (createdataform[k] === routes[m]) {
                        if (asign_dataForm[routes[m]] === undefined) {
                            asign_dataForm[routes[m]] = {}
                        }
                        if (tablas[i].includes('multiple_')) {
                            asign_predeterminados[tablas[i]] = {}
                            if (asign_dataMultiple[routes[m]] === undefined) {
                                asign_dataMultiple[routes[m]] = {}
                                asign_predeterminados[routes[m]] = {}
                            }

                            asign_dataMultiple[routes[m]][tablas[i]] = {}
                            if (asign_dataForm[routes[m]][tablas[i].substring(9) + '_nuevos'] === undefined) {
                                asign_dataForm[routes[m]][tablas[i].substring(9) + '_nuevos'] = []
                                asign_dataForm[routes[m]][tablas[i].substring(9) + '_activos'] = []
                                asign_dataForm[routes[m]][tablas[i].substring(9) + '_inits'] = []
                            }
                        }
                        if (asign_dataForm[routes[m]][tablas[i]] === undefined) {
                            asign_dataForm[routes[m]][tablas[i]] = {}
                        }
                        asign_dataForm[createdataform[k]][tablas[i]][campos[j]] = dataForm_object[tablas[i]][campos[j]].datatype.predeterminate

                    }
                }
            }
        }
    }

    return { dataMultiple: asign_dataMultiple, predeterminados: asign_dataForm, dataForm: asign_dataForm, dataPost: asign_dataPost, datadb: asign_datadb, dataGet: asign_dataGet, dataIndex: asign_dataIndex, permisos_modulos: permisos_modulos }
}